import React, {useEffect, useState} from 'react'
import {connect, useSelector} from "react-redux";
import {Col, Row, Spinner} from "reactstrap";

// components
import WidgetsForm from "./_form";
import {GenericButton} from "../../../../components/buttons/customButtons";

// labels
import {
    ADD_STATE,
    REMOVE_STATE,
    setApp,
    setFilter,
    setForm,
    setItem
} from "../../../../redux/actions/generics/IndexedActions";

// utils
import {getStateByPath} from "../../../../redux/selectors";
import {GenericContainer} from "../../../../components/containers/GenericContainer";
import {genericIndexedActions} from "../../../../redux/actions/generics/GenericIndexedActions";
import {widgetProvider} from "../../../../providers/landings/widgetProvider";
import {GenericTableButton} from "../../../../components/buttons/buttonsActions";
import {TT_EDIT, TT_REMOVE} from "../../../../components/i18n/toolTips";
import {sectionWidgetService} from "../../../../jwt/_services/landings/sectionWidgetService";
import {ConfirmDelete} from "../../../../components/confirmAlert/ConfirmDelete";
import Showdown from "showdown";
import TranslateButton from "../../../../components/buttons/TranslateButton";
import {widgetService} from "../../../../jwt/_services/landings/widgetService";


const Widgets = (props) => {
    const path = `${props.path}/widgets`;
    const parentComponentState = useSelector(state => getStateByPath(state, props?.path));
    const componentState = useSelector(state => getStateByPath(state, path));

    const { app, domainObject } = parentComponentState?.data || {};
    const {  listDomainObjects } = componentState?.data || [];
    const {  loading, filter } = componentState?.data || {};
    const [selectedWidget, setSelectedWidget] = useState(null);
    
    const [showFormModal, setShowFormModal] = useState(false);

    useEffect(() => {
        props.ADD_STATE(path);

        return () => {
            props.REMOVE_STATE(path);
        }
    }, []);

    useEffect( () => {
        if (!app || !domainObject?.id)
            return;

        props.setApp(path, app);

        props.setFilter(path , {
            fbDataBase : { id : app?.fbDataBase?.id },
            item: {
                section : { id : domainObject?.id }
            }
        });
    }, [ domainObject, app ]);

    useEffect(() => {
        if(!filter)
            return

        genericIndexedActions.search(path, sectionWidgetService, 0, 1000, filter)
    }, [ filter ]);

    const onCreateItem = () => {
        props.setItem(path, null);
        props.setForm(path)
        setShowFormModal(!showFormModal);
    }

    const onEditItem = (data) => {
        props.setItem(path, data);
        props.setForm(path, true, false, false)
        setShowFormModal(!showFormModal);
    }

    const onLinkItem = () => {
        if(!selectedWidget) return;

        const requestData = {
            fbDataBase : { id : app?.fbDataBase?.id },
            item:{
                section: {id: domainObject?.id},
                widget: {id: selectedWidget},
                showOrder: (listDomainObjects?.length || 0)
            }
        }

        genericIndexedActions.save(path, sectionWidgetService, requestData)
    }

    const confirmDelete = data => ConfirmDelete({
        path,
        data,
        closeOnEscape: false,
        closeOnClickOutside: false,
        fbDataBaseId: app?.fbDataBase?.id,
        service: sectionWidgetService,
        remove : genericIndexedActions.delete,
    } );

    const handleShowFormModal = () => setShowFormModal(!showFormModal);

    const converter = new Showdown.Converter();

    const renderContent = (item, index) => <div key={index} className={'dnd-item'}>
        <Row>
            <Col className={'dnd-title'}>
                {item?.widget?.title}
            </Col>
            <Col>
                <div className={'actions'}>
                    <GenericTableButton
                        toolTip={TT_EDIT}
                        icon={'fa-pen'}
                        permission={'edit'}
                        onClick={()=> onEditItem(item?.widget) }
                    />
                    <TranslateButton
                        item={item?.widget}
                        service={ widgetService }
                        path={path}
                    />
                    <GenericButton
                        style={'danger-secondary'}
                        toolTip={TT_REMOVE}
                        icon={'fa-minus'}
                        permission={'delete'}
                        onClick={() => confirmDelete(item)}
                    />
                </div>
            </Col>
        </Row>
        {/*<Row>*/}
        {/*    <Col className={'dnd-title'}>*/}
        {/*        <ReactMde*/}
        {/*            readOnly={true}*/}
        {/*            value={item?.widget?.langs[0]?.description}*/}
        {/*            showControls={false}*/}
        {/*            selectedTab={'preview'}*/}
        {/*            // onTabChange={setSelectedTab}*/}
        {/*            generateMarkdownPreview={(markdown) =>*/}
        {/*                Promise.resolve(converter.makeHtml(markdown))*/}
        {/*            }*/}
        {/*        />*/}
        {/*    </Col>*/}
        {/*</Row>*/}
    </div>

    const onReorderItems = reorderProps => {
        let dataRequest = {
            fbDataBase:  { id : app?.fbDataBase?.id },
            items: []
        }

        for (const reorderedItem of reorderProps?.list) {
            // Validar si el ítem tiene un id (es decir, si existe en la base de datos)
            if (reorderedItem?.id) {
                // Buscar el ítem en listDomainObjects
                let domainObject = listDomainObjects.find(domainObject => domainObject.id === reorderedItem.id);

                if (domainObject?.showOrder !== reorderedItem?.showOrder) {
                    dataRequest.items.push({
                        id: domainObject.id,
                        showOrder: reorderedItem.showOrder
                    })
                }

            }
        }

        genericIndexedActions.reorder(path, sectionWidgetService, dataRequest)
    }

    return <>
        { loading ? <Spinner animation="border"/> :
            <GenericContainer
                titlle={'Widgets'}
                listItems={listDomainObjects}
                renderContent={renderContent}

                provider={widgetProvider}
                option={selectedWidget}
                setOption={setSelectedWidget}
                providerFilter={{ fbDataBase : { id: app?.fbDataBase?.id }, onlyRegistered: true }}

                onAddItem={onLinkItem}
                onCreateItem={onCreateItem}
                onReorderItems={onReorderItems}
            />
        }
        {
            showFormModal && <WidgetsForm
                path={props.path}
                isOpen={showFormModal}
                toggle={handleShowFormModal}
            />
        }
    </>
}

const mapStateToProps = state => ({})
const mapActionsToProps = ({
    ADD_STATE,
    REMOVE_STATE,
    setItem, setForm, setFilter,
    setApp,
})

export default connect(mapStateToProps, mapActionsToProps)(Widgets);